<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
	export default {
		data() {
			return {
				
			}
		},
		created() {
			
		}
	}
</script>

<style>
	.grayAll {
	    filter:grayscale(.95);
	    -webkit-filter:grayscale(.95);
	
	    filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
	    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=.95 );
	}
	ul li {
	margin: 0px;
	padding: 0px;
	list-style-type: none;
}
	
	
	@import "./assets/css/animate.compat.min.css";
	@import "./assets/css/base.min.css";
	@import "./assets/css/bootstrap.css";
	@import "./assets/css/jquery.validator.css";
	@import "./assets/css/main.css";
	@import "./assets/css/owl.carousel.css";
	@import "./assets/css/share.min.css";
	@import "./assets/css/style.css";
	@import "./assets/css/app.css";
	.ellipsis-2 {
	  display: -webkit-box;
	  -webkit-box-orient: vertical;
	  -webkit-line-clamp: 2;  /* 限制显示行数 */
	  overflow: hidden;
	  text-overflow: ellipsis;  /* 溢出内容显示省略号 */
	}
	.bounding-box {
	  box-shadow: 0 0 20px #c6c6c6 !important;
	}
</style>
